module.exports = __webpack_public_path__ + "static/media/detail_0027_f.58f6335b.jpg";